export default function IconAddTable() {
  return (
    <svg height="26" width="26">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        d="M4 2 L20 2 A4 4 0 0 1 22 4 L22 14 M14 22 L4 22 A4 4 0 0 1 1 18 L1 4 A4 4 0 0 1 5 2 M22 17 L22 25 M18 21 L26 21 M1 8 L22 8"
      />
    </svg>
  );
}
